import styled, { css } from 'styled-components';

import { rowHeight, menuHeight, visibleRowsByHeightSet } from '../constants';

import { elevationTokens, colorTokens } from '../../../tokens/globals/tokens';
import { SLIDER_SLIDING_ANIMATION_LENGTH_MS } from './SpreadsheetSlider/slider-components';

const SpreadsheetWrapper = styled.div`
  &[data-slider='closed'] {
    --slider-width: 60px;
  }
  &[data-slider='open'] {
    --slider-width: 420px;
  }

  background-color: ${colorTokens.GlobalBrandWhite};
  border-bottom: 1px solid ${colorTokens.GlobalBrandGray40};
  border-left: 0;
  border-right: 1px solid ${colorTokens.GlobalBrandGray40};
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
  display: grid;
  transition: all ${SLIDER_SLIDING_ANIMATION_LENGTH_MS}ms ease-in-out;
  z-index: ${elevationTokens.GlobalSpreadsheet};

  grid-template-columns: ${({ theme }) => (theme.hasSlider ? '1fr var(--slider-width)' : '1fr')};
  grid-template-rows: ${({ theme }) => (theme.hasMenu ? '60px 1fr' : '1fr')};

  ${({ theme }) => {
    const spreadsheetHeight = rowHeight * visibleRowsByHeightSet[theme.height];
    const calculatedMenuHeight = theme.hasMenu ? menuHeight : 0;
    const calculatedRequiredHeight = theme.hasRequired ? 30 : 0;
    const calculatedHeight =
      theme.height === 'full'
        ? `calc(100dvh - ${theme.heightOffset})`
        : `${spreadsheetHeight + calculatedMenuHeight + calculatedRequiredHeight}px`;
    return css`
      height: ${calculatedHeight};
    `;
  }};
`;

export { SpreadsheetWrapper };
